import Stack from '@liquidweb-dev/undercurrent/Stack';
import SvgIcon from '@liquidweb-dev/undercurrent/SvgIcon';

interface TrustPilotStarsProps {
	iconSize?: number;
	rating?: string;
}

interface TrustPilotStarSVGProps {
	iconSize?: number;
	key?: number;
	svgStyles?: React.CSSProperties;
}

const TrustPilotStarSVG = ({
	iconSize,
	key,
	svgStyles,
}: TrustPilotStarSVGProps) => {
	return (
		<SvgIcon
			sx={(theme) => ({
				width: `${iconSize}px`,
				height: `${iconSize}px`,
				color: theme.vars.palette.uc.bg.main,
			})}
			key={key}
			viewBox="0 -2 18 23"
			xmlns="http://www.w3.org/2000/svg"
			style={{ ...svgStyles }}
		>
			<path
				fill="currentColor"
				d="M9.70137 14.1736L13.9265 13.0972L15.6995 18.4581L9.70137 14.1736ZM19.3956 7.24376H11.9891L9.70137 0.306885L7.41365 7.24376L0 7.23672L5.99812 11.5212L3.7104 18.4581L9.70137 14.1736L13.4046 11.5283L19.3956 7.24376Z"
			/>
		</SvgIcon>
	);
};

export const TrustPilotStars = ({
	iconSize = 16,
	rating = '4.5',
}: TrustPilotStarsProps) => {
	const [fullStar, halfStar] = rating.split('.');
	return (
		<Stack
			sx={{
				flexDirection: 'row',
				gap: 25,
			}}
		>
			{[...Array(Number(fullStar))].map((_, index) => {
				return (
					<Stack
						key={`full-star-${index}`}
						sx={({ vars }) => ({
							background: vars.palette.uc.success.icon.medium,
						})}
					>
						<TrustPilotStarSVG iconSize={iconSize} />
					</Stack>
				);
			})}
			{Number(halfStar) >= 5 && (
				<Stack
					sx={({ vars }) => ({
						background: vars.palette.uc.success.icon.medium,
						width: '8px',
						overflow: 'hidden',
						marginRight: '8px',
					})}
				>
					<TrustPilotStarSVG iconSize={iconSize} />
				</Stack>
			)}
		</Stack>
	);
};

export default TrustPilotStars;
